module.exports = __webpack_public_path__ + "static/img/1-msg.a4daa85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/1-msg.png
// module id = sMGs
// module chunks = 1